
import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'

/**
 * Defines a button that sends the user to a new "page"
 * using React DOM Router.
 * 
 * Thanks: https://stackoverflow.com/a/49439893/5046197
 */
const LinkButton = (props) => {
  const {
    history,
    location,
    match,
    staticContext,
    to,
    onClick,
    // ⬆ filtering out props that `button` doesn’t know what to do with.
    ...rest
  } = props;

  return (
    <button
      {...rest} // `children` is just another prop!
      onClick={(event) => {
        onClick && onClick(event)
        history.push(to)
      }}
    />
  )
}

LinkButton.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
}

export default withRouter(LinkButton)
